
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/stock-information",
      function () {
        return require("private-next-pages/investor/stock-information.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/stock-information"])
      });
    }
  